import PropTypes from "prop-types"
import { GROUP } from "../../shapes"
import "./style.scss"

function GroupHeaders({ groups }) {
  return <tr className="category-headers">
    <th />
    {groups.map(({ id, label, width }) => <th key={id} colSpan={width}>{label}</th>)}
  </tr>
}

GroupHeaders.propTypes = {
  groups: PropTypes.arrayOf(GROUP).isRequired,
}

export default GroupHeaders
